"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Modal = require("@insided/shared/uikit/Modal");

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var BanUserModal = function BanUserModal(_ref) {
  var onClose = _ref.onClose,
      userName = _ref.userName,
      userId = _ref.userId,
      banUser = _ref.banUser,
      isLoading = _ref.isLoading;
  return (0, _preact.h)(_preactPortal.default, {
    into: "body"
  }, (0, _preact.h)(_Modal.Modal, {
    isOpen: true,
    isControl: true,
    size: "small"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Ban User",
    onClose: onClose
  }), (0, _preact.h)(_Modal.ModalBody, null, "You are about to ban user: ", userName, " (", userId, "). Are you sure?"), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
    title: "Cancel",
    onClick: onClose
  }), (0, _preact.h)(_Button.default, {
    title: "Ban",
    variant: "danger",
    onClick: banUser,
    isLoading: isLoading
  }))));
};

var _default = BanUserModal;
exports.default = _default;